import Request, { RequestParams, RequestPageParams } from './request'
import { getSingletonStore } from 'common/utils'
import { DIOX } from './index'

class DAppService extends Request {
  constructor(props: RequestParams) {
    super(props)
  }

  getDAppInfo(symbol: string) {
    return this.get<DIOX.DAppInfoRespone>('', { params: { module: 'dapp', action: 'baseinfo', symbol } })
  }

  getDAppList(query?: RequestPageParams) {
    return this.get<DIOX.DAppResponse>('', { params: { module: 'dapp', action: 'listdapp', ...query } })
  }

  checkContract(cid: string) {
    return this.get<{ Contract: string }>('', {
      params: {
        module: 'contract',
        action: 'check',
        cid,
      },
    })
  }
}

export default getSingletonStore<DAppService>(DAppService, { baseURL: '/api' })
